import { ModalBody, ModalFooter } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import FormFieldset from 'components/forms/form/FormFieldset';
import SelectField from 'components/forms/selectField/SelectField';
import TextField from 'components/forms/textField/TextField';
import Button from 'components/button/Button';
import { CustomDataFieldType } from 'models/CustomDataField';
import useAppModal from 'hooks/useAppModal';
import { useFormContext } from 'react-hook-form';

const AddCustomFieldModalFormFields = ({ modalId }: { modalId: string }) => {
  const {
    formState: { isValid },
  } = useFormContext();
  const { closeModal } = useAppModal();
  const { t } = useTranslation();

  const fieldTypes = [
    {
      label: CustomDataFieldType.LONG_TEXT,
      value: CustomDataFieldType.LONG_TEXT,
    },
    {
      label: CustomDataFieldType.TEXT,
      value: CustomDataFieldType.TEXT,
    },
  ];

  return (
    <FormFieldset>
      <ModalBody>
        <TextField
          colSmInput={9}
          colSmLabel={3}
          name="name"
          label={t('pageAutomations.customFields.fieldName')}
          required
        />
        <SelectField
          colSmInput={9}
          colSmLabel={3}
          name="type"
          options={fieldTypes}
          label={t('pageAutomations.customFields.fieldType')}
        />
      </ModalBody>

      <ModalFooter>
        <Button
          type="button"
          bsStyle="secondary"
          onClick={() => {
            closeModal(modalId);
          }}
        >
          {t('common.cancel')}
        </Button>
        <Button
          type="submit"
          bsStyle="primary"
          data-testid="add-custom-field-modal-submit-button"
          disabled={!isValid}
        >
          {t('common.add')}
        </Button>
      </ModalFooter>
    </FormFieldset>
  );
};

export default AddCustomFieldModalFormFields;
